import Vue from "vue";
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import { Component, Watch } from "vue-property-decorator";
import { stringMaxLength } from "../../../assets/validation/common";
import ListItemNumberModel from "../../../models/listItemNumberModel";
import ContractorSearchItemModel from "../../../models/rest/contractor/contractorSearchItemModel";
import DepartmentItemRestModel from "../../../models/rest/register/departmentItemRestModel";
import SupervisorCarrierDocumentOrderRequirementRestModel from "../../../models/rest/supervisor/supervisorCarrierDocumentOrderRequirementRestModel";
import SupervisorRestModel from "../../../models/rest/supervisor/supervisorRestModel";
import SupervisorSendToEmailAddressModel from "../../../models/rest/supervisor/supervisorSendToEmailAddressModel";

@Component({
    components: {
        VuePdfEmbed,
    },
})
export default class SendingEmailDialog extends Vue {
    showCurrentSupervisorCarrierDocumentViewCard = false;
    isDocumentLoading = false;
    showAlert = false;

    validation = {
        carrierEmail: [
            stringMaxLength(this.$i18n, this.$t("user.email"), 95),
            (value: string) => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || this.$t("common.validationErrorValidEmail");
            }],
        carrierOrderRequirement: [(value: number) => !!value || this.$t("common.validationErrorRequired")],
        emailNote: [stringMaxLength(this.$i18n, this.$t("user.email"), 512)],
    }

    get isLoading(): boolean {
        return this.$store.direct.state.loading;
    }

    get showDialog(): boolean {
        return this.$store.direct.state.supervisor.showSendingEmailDialog;
    }

    get title(): string {
        return this.$store.direct.state.supervisor.sendingEmailDialogTitle;
    }

    get sendToEmailAddressArray(): SupervisorSendToEmailAddressModel[] {
        return this.$store.direct.state.supervisor.sendingEmailDialogSendToEmailAddressArray;
    }

    set sendToEmailAddressArray(val: SupervisorSendToEmailAddressModel[]) {
        this.$store.direct.commit.supervisor.setSendingEmailDialogSendToEmailAddressArray(val);
    }

    get sendFromEmailAddressList(): string[] {
        return this.$store.direct.state.common.dispoEmailAddressList;
    }

    get sendFromEmailAddress(): string {
        return this.$store.direct.state.supervisor.sendingEmailDialogSendFromEmailAddress;
    }

    set sendFromEmailAddress(val: string) {
        this.$store.direct.commit.supervisor.setSendingEmailDialogSendFromEmailAddress(val);
    }

    get emailNote(): string {
        return this.$store.direct.state.supervisor.sendingEmailDialogEmailNote;
    }

    set emailNote(val: string) {
        this.$store.direct.commit.supervisor.setSendingEmailDialogEmailNote(val);
    }

    get currentUserDefaultDepartmentId(): number {
        return this.$store.direct.state.auth.currentUserDefaultDepartmentId;
    }

    get carrierOrderRequirementList(): SupervisorCarrierDocumentOrderRequirementRestModel[] {
        return this.$store.direct.state.supervisor.supervisorCarrierDocumentOrderRequirementList;
    }

    get carrierOrderRequirementId(): number {
        return this.$store.direct.state.supervisor.sendingEmailDialogCarrierOrderRequirementId;
    }

    set carrierOrderRequirementId(val: number) {
        this.$store.direct.commit.supervisor.setSendingEmailDialogCarrierOrderRequirementId(val);
    }

    get departments(): DepartmentItemRestModel[] {
        return this.$store.direct.state.contractor.contractorAssets.departments;
    }

    get cieszynDepartmentIdcs(): number[] {
        const cieszynDepartmentIdcs = this.departments.filter((x: ListItemNumberModel) => {
            if (x.text.includes("Cieszyn")) {
                return x.value;
            }
        }).map((x: ListItemNumberModel) => {
            return x.value;
        })
        return cieszynDepartmentIdcs;
    }

    get supervisor(): SupervisorRestModel {
        return this.$store.direct.state.supervisor.supervisor;
    }

    get selectedContractorCarrier(): ContractorSearchItemModel {
        return this.$store.direct.state.supervisor.selectedContractorCarrier;
    }

    get contractorCarrierEmailList(): ListItemNumberModel[] {
        return this.$store.direct.state.contractor.emailAddressList;
    }

    set contractorCarrierEmailList(val: ListItemNumberModel[]) {
        this.$store.direct.commit.contractor.setEmailAddressList(val);
    }

    get contractorCarrierEmailListFormatted(): string[] {
        return this.contractorCarrierEmailList.map((x: ListItemNumberModel) => {
            return x.text;
        })
    }

    get currentSupervisorCarrierDocument(): string {
        const currentSupervisorCarrierDocument = this.$store.direct.state.supervisor.currentSupervisorCarrierDocument;
        if (typeof (currentSupervisorCarrierDocument) === "string") {
            this.showCurrentSupervisorCarrierDocumentViewCard = true;
            return 'data:application/pdf;base64,' + currentSupervisorCarrierDocument;
        }
        return "";
    }

    @Watch("sendFromEmailAddressList")
    async emailFromAddressListHandles() {
        this.$store.direct.commit.contractor.setContractorAssetsLoaded(false);
        await this.$store.direct.dispatch.contractor.loadContractorAssets();
        await this.$store.direct.dispatch.supervisor.loadSupervisorAssets();

        if (this.cieszynDepartmentIdcs.includes(this.currentUserDefaultDepartmentId)) {
            this.sendFromEmailAddress = this.sendFromEmailAddressList[1];
        }
        else {
            this.sendFromEmailAddress = this.sendFromEmailAddressList[0];
        }

        if (this.departments != undefined) {
            const foundDepartment = this.departments.find((x: DepartmentItemRestModel) => x.value == this.supervisor.locationId)
            this.carrierOrderRequirementId = foundDepartment?.defaulSupervisorCarrierOrderRequirementId ?? 0;

            if (this.carrierOrderRequirementId != 0) {
                this.onCarrierOrderRequirementIdChange(this.carrierOrderRequirementId, 0);
            }
        }
    }

    @Watch("selectedContractorCarrier")
    async selectedContractorCarrierHandles() {
        if (this.selectedContractorCarrier != null && this.selectedContractorCarrier.value != null && this.selectedContractorCarrier.value != undefined) {
            this.$store.direct.dispatch.contractor.loadEmailAddressList({ contractorId: this.selectedContractorCarrier.value });
        }
    }

    @Watch("carrierOrderRequirementId")
    async onCarrierOrderRequirementIdChange(newValue: number, oldValue: number) {
        if (newValue && this.supervisor?.id && this.selectedContractorCarrier?.value) {

            if (this.isDocumentLoading) {
                this.showAlert = true;
                return;
            }

            await this.$store.direct.dispatch.supervisor.showSupervisorCarrierDocument({
                supervisorId: this.supervisor.id,
                contractorCarrierId: this.selectedContractorCarrier.value
            });
        }
    }

    addSendToEmailAddress() {
        this.sendToEmailAddressArray.push({ emailAddress: "" });
    }

    removeSendToEmailAddress(index: number) {
        this.sendToEmailAddressArray.splice(index, 1);
    }

    handleDocumentLoad() { // start loading document
        this.isDocumentLoading = true
    }

    handleDocumentRender() { // stop loading document
        this.isDocumentLoading = false
        this.showAlert = false;
    }

    cancelClick() {
        this.$store.direct.dispatch.supervisor.isNotConfirmedSendingEmailDialog();
    }

    showSupervisorCarrierDocument() {
        const valid = (this.$refs.form as Vue & { validate: () => boolean }).validate();
        if (valid) {
            this.$store.direct.dispatch.supervisor.showSupervisorCarrierDocument({ supervisorId: this.supervisor.id, contractorCarrierId: this.selectedContractorCarrier.value });
        }
    }

    async saveClick() {
        const valid = (this.$refs.form as Vue & { validate: () => boolean }).validate();
        if (valid) {
            await this.$store.direct.dispatch.supervisor.isConfirmedSendingEmailDialog();
            this.contractorCarrierEmailList = [] as ListItemNumberModel[];
        }
    }
}
